<div class="category-item" [ngClass]="{ underlined: underlined }">
  @if (icon) {
  <div class="icon-container">
    <div [class]="icon.class">
      <i [class]="icon.icon"></i>
    </div>
  </div>
  }
  <div class="content" [ngClass]="{ underlined: underlined }">
    <div class="secondary-content left" style="color: var(--text-label);">{{ label }}</div>
    <div class="secondary-content right">
      @if (value) { @if (isLoading) {
      <p-skeleton width="3rem" height="1rem" />
      } @else {
      <div class="value">{{ value }}</div>
      } }
    </div>
    <div class="chevron">
      <i class="pi pi-chevron-right"></i>
    </div>
  </div>
</div>
